module.exports = __webpack_public_path__ + "img/产品首页图片.c5378138.png";